import { call, put, takeLeading } from 'redux-saga/effects';
import { api } from '@frontegg/rest-api';
import { actions } from '../reducer';

/**
  Load entitlements list
 */
export function* loadEntitlements() {
  yield put(actions.setEntitlementsState({
    loading: true,
    error: null
  }));
  try {
    const entitlements = yield call(api.entitlements.loadEntitlements);
    yield put(actions.setEntitlementsState({
      entitlements,
      loading: false
    }));
  } catch (e) {
    yield put(actions.setEntitlementsState({
      error: e.message,
      loading: false
    }));
  }
}
export function* entitlementsSagas() {
  yield takeLeading(actions.loadEntitlements, loadEntitlements);
}